module.exports = __webpack_public_path__ + "img/18.1.1c9df0c4.jpg";